// CacheKey a6cf8d17fad6c47fcf426da7575f7928
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  ro: {
    date: {
      abbr_month_names: [
        null,
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
      ],
      month_names: [
        null,
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "duminică",
        "luni",
        "marți",
        "miercuri",
        "joi",
        "vineri",
        "sâmbătă"
      ],
      formats: {
        default: "%d.%m.%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "Ora de Est",
      edt: "Ora de Est",
      cst: "Ora Centrală",
      cdt: "Ora Centrală",
      mst: "Ora Munților",
      mdt: "Ora Munților",
      pst: "Ora Pacificului",
      pdt: "Ora Pacificului",
      hst: "Ora Hawaii-Aleutiană",
      hdt: "Ora Hawaii-Aleutiană",
      akst: "Ora Alaska",
      akdt: "Ora Alaska"
    }
  }
}

